export const POSTAGE_PURCHASE_REQUEST_FAILURE = 'POSTAGE_PURCHASE_REQUEST_FAILURE';
export const postagePurchaseFailure = (sellerLabelProviderId, jobGuid, error) => ({
  type: POSTAGE_PURCHASE_REQUEST_FAILURE,
  sellerLabelProviderId,
  jobGuid,
  error,
});

export const POSTAGE_PURCHASE_DEFERRED = 'POSTAGE_PURCHASE_DEFERRED';
export const postagePurchaseDeferred = (jobGuid, costReviewData) => ({
  type: POSTAGE_PURCHASE_DEFERRED,
  jobGuid,
  costReviewData,
});

export const POSTAGE_AND_INSURANCE_PURCHASE_REQUEST = 'POSTAGE_AND_INSURANCE_PURCHASE_REQUEST';
export const postageAndInsurancePurchaseRequest = (
  jobGuid,
  providers,
  insurances,
  wallets = [],
  tracking,
  onAddFundsComplete,
  closeModal,
) => ({
  type: POSTAGE_AND_INSURANCE_PURCHASE_REQUEST,
  jobGuid,
  providers,
  insurances,
  wallets,
  tracking,
  onAddFundsComplete,
  closeModal,
});

export const POSTAGE_AND_INSURANCE_PURCHASE_SUCCESS = 'POSTAGE_AND_INSURANCE_PURCHASE_SUCCESS';
export const postageAndInsurancePurchaseSuccess = (jobGuid) => ({
  type: POSTAGE_AND_INSURANCE_PURCHASE_SUCCESS,
  jobGuid,
});

export const POSTAGE_AND_INSURANCE_PURCHASE_FAILURE = 'POSTAGE_AND_INSURANCE_PURCHASE_FAILURE';
export const postageAndInsurancePurchaseFailure = (jobGuid, errorMessage) => ({
  type: POSTAGE_AND_INSURANCE_PURCHASE_FAILURE,
  jobGuid,
  errorMessage,
});

export const CLOSE_ORDER_DETAILS_MODAL_ON_BILLING_INFO_LINK_CLICK = 'CLOSE_ORDER_DETAILS_MODAL_ON_BILLING_INFO_LINK_CLICK';
export const closeOpenedModalsModals = () => ({
  type: CLOSE_ORDER_DETAILS_MODAL_ON_BILLING_INFO_LINK_CLICK,
});

export const BYPASS_COST_REVIEW = 'BYPASS_COST_REVIEW';
export const bypassCostReview = (jobGuid) => ({
  type: BYPASS_COST_REVIEW,
  jobGuid,
});
